export default {
  getYears () {
    this.$http.get('/v1/dweller/file/years')
    .then(({data}) => {
      this.years = data
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/files/resources/methods.js